<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Asignar Nro. de Ticket</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formTicket" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Nro. Ticket </mat-label>
                <input
                    matInput
                    type="string"
                    formControlName="nroTicket"
                    required
                />

                <mat-error *ngIf="nroTicket.hasError('required')">
                    Debe ingresar el Nro. de Ticket
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formTicket.value"
            [disabled]="!formTicket.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
